<template>
  <TablePaginatedToggleButton
      label="Popular Places"
      sublabel="What attractions do your passengers view the most?"
      :main-list="itemData"
      :is-global-percent="isGlobalPercent"
      :override-headers="overrideHeaders"
      :tabs-list="tabsList"
      :visible-pages-numbers="5"
      is-has-tabs
      is-show-total-label
  />
</template>

<script>
import { mapGetters } from 'vuex';
import TablePaginatedToggleButton from '../../../TablePaginatedToggleButton.vue';

export default {
  name: 'PagedListPopularPlacesNoHighlights',
  components: {
    TablePaginatedToggleButton,
  },

  props: {
    itemData: {
      type: [Array],
      default() {
        return ([]);
      },
    },
  },

  data: () => ({
    overrideHeaders: [
      {
        text: '', value: 'label', tabs: ['every'],
      },
      {
        text: 'Total', value: 'value', type: 'bar', tabs: ['default'],
      },
      {
        text: 'Total', value: 'total', type: 'number', tabs: ['details'],
      },
      {
        text: 'View Video', value: 'click', type: 'number', tabs: ['details'],
      },
      {
        text: 'Map Spotlight', value: 'pins', type: 'number', tabs: ['details'],
      },
      {
        text: 'AI Feed', value: 'highlights', type: 'number', tabs: ['details'],
      },
    ],
    tabsList: [
      { text: 'Overview', name: 'default' },
      { text: 'Details', name: 'details' },
    ],
  }),

  computed: {
    ...mapGetters({
      isGlobalPercent: 'metrics/isGlobalPercent',
    }),
  },
};
</script>
